import { render, staticRenderFns } from "./protocol-insert-review.vue?vue&type=template&id=74993002&"
import script from "./protocol-insert-review.vue?vue&type=script&lang=js&"
export * from "./protocol-insert-review.vue?vue&type=script&lang=js&"
import style0 from "./protocol-insert-review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports